import { render } from "./App.vue?vue&type=template&id=52372ca5&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=52372ca5&lang=scss"

import exportComponent from "D:\\Data\\Dev\\Geosat\\90024-Glaciorisk-V2\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__